import { ConcreteEncodable } from "./ConcreteEncodable";

import { BenchmarkLockLifeCycleEventImplEncoder } from "../../encoder/BenchmarkLockLifeCycleEventImplEncoder";

import * as CubiqTS from "../../index";
import { BenchmarkLockLifeCycleEvent } from "../BenchmarkLockLifeCycleEvent";

export class BenchmarkLockLifeCycleEventImpl
  extends ConcreteEncodable
  implements BenchmarkLockLifeCycleEvent
{
  public static enType: string = "com.bcdfx.model.event.lifecycle.BenchmarkLockLifeCycleEventImpl";

  /*FID=1*/
  public eventTypeId: CubiqTS.FxLifeCycleEventType;
  /*FID=2*/
  public orderIds: Array<string> | null = null;
  /*FID=3*/
  public lockType: CubiqTS.LockType;
  /*FID=4*/
  public lockUserId: CubiqTS.Long | null = null;
  /*FID=5*/
  public lockUser: string;
  /*FID=6*/
  public clOrderIds: Array<string> | null = null;
  /*FID=7*/
  public id: string;
  /*FID=8*/
  public abort: boolean;
  /*FID=9*/
  public errors: CubiqTS.Errors | null = null;
  /*FID=10*/
  public orderDatas: Array<CubiqTS.OrderData> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = BenchmarkLockLifeCycleEventImplEncoder.Instance;
    this.setEncodableType(BenchmarkLockLifeCycleEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "BenchmarkLockLifeCycleEventImpl[" +
      "eventTypeId=" +
      this.eventTypeId +
      "orderIds=" +
      this.orderIds +
      "lockType=" +
      this.lockType +
      "lockUserId=" +
      this.lockUserId +
      "lockUser=" +
      this.lockUser +
      "clOrderIds=" +
      this.clOrderIds +
      "id=" +
      this.id +
      "abort=" +
      this.abort +
      "errors=" +
      this.errors +
      "orderDatas=" +
      this.orderDatas +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
